import { render, staticRenderFns } from "./energyCosts.vue?vue&type=template&id=4defbf15&scoped=true&"
import script from "./energyCosts.vue?vue&type=script&lang=js&"
export * from "./energyCosts.vue?vue&type=script&lang=js&"
import style0 from "./energyCosts.vue?vue&type=style&index=0&id=4defbf15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defbf15",
  null
  
)

export default component.exports